module.exports = __webpack_public_path__ + "static/media/boy-two.05373468.jpg";